import 'whatwg-fetch';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { setOptions, overrideComponent } from '@sheerid/jslib';
import { StepStudentPersonalInfoComponent } from './StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './StepSuccess';
import { StepErrorComponent } from './StepErrorComponent';
import './index.css';
import App from './App';
import { StepDocUploadComponent } from './StepDocUploadComponent';


setOptions({
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'info',
    messagesWithLocale: {
        'en-GB': {},
        'en-US' : {
            "birthDate" : "BIRTH DATE",
            "verifyMyStudentStatus" : "Verify my student status",
            "step" : {
                "pending" : {
                    "subtitle" : "SheerID is reviewing your documents, <span style='display:inline-block;'>to confirm your status.</span>",
                    "subtitle2" : "This process may take up to 20 minutes.",
                    "subtitle3" : "Wait here or let us notify you of the outcome. <span style='display:inline-block;'>You will be contacted via email.</span>",
                },
                "docUpload" : {
                    "notAStudent" : "Not a student? You can still get SiriusXM. <a href=' https://www.siriusxm.com/phx/offer/dual-offer?intcmp=SheerID_FL_all_SXIR_MPP_3for1_091619_PS'>Try it now.</a>"
                },
                "success" : {
                    "subtitle" : "Your eligibility has been confirmed.",
                    "redirectButtonText" : "Continue to checkout",
                },
                "error" : {
                    "tryAgain" : "try again",
                    "redirectButtonText" : "Continue",
                },
            },
            "error" : "Sorry, looks like we're having technical difficulties.",
            "errorId" : {
                "DEFAULT" : "Please {tryAgain} later or continue to see other offers.",
            },
        },
    }
});

overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
//@ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
//@ts-ignore
overrideComponent('StepErrorComponent', StepErrorComponent);

ReactDOM.render(<App />, document.getElementById('root'));
